

export interface ProblemDetails {
  type?: string; // URI reference for the error type
  title?: string; // Short summary of the problem
  status?: number; // HTTP status code
  detail?: string; // Human-readable explanation of the error
  instance?: string; // URI reference for the specific occurrence
  [key: string]: any; // Allow additional custom fields
}

export interface ValidationProblemDetails extends ProblemDetails {
  errors?: Record<string, string[]>;
  message?: string;
}

export class ValidationError extends Error {
  public errors: Record<string, string>;

  constructor(message: string, errors: Record<string, string>) {
    super(message); // Pass the message to the base Error class
    this.name = "ValidationError"; // Set the error name
    this.errors = errors; // Store the formatted errors
    // Ensure the correct prototype chain for instanceof checks
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}

export class ProblemError extends Error {
  public title: string | null;
  public detail: string | null;

  constructor(message: string, title: string | null, detail: string | null) {
    super(message); // Pass the message to the base Error class
    this.title = title;
    this.detail = detail;
    this.name = "ProblemError"; // Set the error name
    // Ensure the correct prototype chain for instanceof checks
    Object.setPrototypeOf(this, ProblemError.prototype);
  }
}